import {type AgentSubType, AgentSubTypes} from '../types';
import type {AgentTypeDto, GetTokens} from './types';
import agentQuery from './data/agentQuery.json';
import {exceptionToPromiseReject} from './exceptionToPromiseReject';
import {httpElasticCount} from './http/search/httpElastic';
import {mapAgentTypeDto, mapToAgentTypeDto} from './mappers/mapAgentTypeDto';

export const searchAgentsCount = (
  query: string,
  getTokens: GetTokens,
  abortSignal?: AbortSignal,
  mock?: boolean,
): Promise<Map<AgentSubType, number>> => {
  const types: AgentTypeDto[] = AgentSubTypes.map(mapToAgentTypeDto);

  const queries = types.map(type =>
    JSON.stringify(agentQuery, null)
      .replaceAll('${QUERY_PLACEHOLDER}', query)
      .replaceAll('${AGENT_TYPE_PLACEHOLDER}', type),
  );

  return exceptionToPromiseReject(() =>
    httpElasticCount(
      getTokens,
      'ebs-agent-alias',
      queries.map(q => JSON.parse(q)),
      abortSignal,
      mock,
    ).then(response => {
      const map = new Map<AgentSubType, number>();
      for (let i = 0; i < response.responses.length; i++) {
        // The responses are in the same order as the types we sent.
        map.set(
          mapAgentTypeDto(types[i]),
          response.responses[i].hits.total.value,
        );
      }

      return map;
    }),
  );
};
